import { Suspense, useEffect, lazy } from 'react'; //useState
import { Route } from 'react-router-dom'; //, Routes
import PrivateRoute from './components/PrivateRoute';
import { useDispatch } from 'react-redux';
import { LoadUser } from './application/middlewares/auth';

import { MantineProvider, DirectionProvider } from '@mantine/core';
import { Notifications } from '@mantine/notifications';
import CustomRoutes from './components/CustomRouter';
import { LoadingOverlay } from '@mantine/core';

// Containers
const Layout = lazy(() => import('./Layout'));

// Pages
const Login = lazy(() => import('./pages/auth/UserLogin'));
const Register = lazy(() => import('./pages/auth/UserRegister'));
const EmailVerification = lazy(() => import('./pages/auth/EmailVerification'));
const ForgotPasswordRequest = lazy(() => import('./pages/auth/ForgotPasswordRequest'));
const ResetPassword = lazy(() => import('./pages/auth/ResetPassword'));

function App() {
    const dispatch = useDispatch();
    useEffect(() => {
        dispatch(LoadUser() as any); //eslint-disable-next-line
    }, []);
    return (
        <DirectionProvider>
            <MantineProvider withGlobalClasses withCssVariables>
                <Notifications />
                <Suspense fallback={<LoadingOverlay visible zIndex={1000} overlayProps={{ radius: 'sm', blur: 2 }} />}>
                    <CustomRoutes>
                        <Route path="login" element={<Login />} />
                        <Route path="register" element={<Register />} />
                        <Route path="verify-email" element={<EmailVerification />} />
                        <Route path="/forgot-password" element={<ForgotPasswordRequest />} />
                        <Route path="/reset-password" element={<ResetPassword />} />
                        <Route
                            path="/*"
                            element={
                                <PrivateRoute>
                                    <Layout />
                                </PrivateRoute>
                            }
                        />
                        <Route path="*" element={<div>Not found</div>} />
                    </CustomRoutes>
                </Suspense>
            </MantineProvider>
        </DirectionProvider>
    );
}

export default App;
